import Api from 'api'

const config = {
  baseURL: '/api/app/v1/security',
}
const api = new Api(config)

api.registration = ({ ...rest }) => api.post('/reg', { ...rest })
api.activate = ({ ...rest }) => api.post('/register/activate', { ...rest })
api.login = ({ ...rest }) => api.post('/auth', { ...rest })
api.recover = ({ ...rest }) => api.post('/password/recover', { ...rest })
api.setPassword = ({ ...rest }) => api.put('/password', { ...rest })
api.start = () => api.post('/auth/start')
api.twoFactor = ({ ...rest }) => api.post('/auth/two_factor', { ...rest })
api.refresh = ({ ...rest }) => api.post('/refresh', { ...rest })
api.logout = () => api.post('/logout')
api.admitadOAuthApply = ({ ...rest }) => api.get('/admitad/oauth', { ...rest })
api.emailRequestConfirmation = () => api.post('/email/request-confirmation')

export default api
